import type { I18nConfig } from "./_type";

import { initReactI18next } from "react-i18next";

import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

/** I18n config. */
const i18nConfig: I18nConfig = {
  locales: ["en"],
  defaultLocale: "en",
  namespaces: ["common"],
  defaultNamespaces: "common",
};

/** I18next options. */
const i18nextOptions = {
  partialBundledLanguages: true,
  ns: i18nConfig.namespaces,
  defaultNS: i18nConfig.defaultNamespaces,
  lng: i18nConfig.defaultLocale,
  fallbackLng: i18nConfig.defaultLocale,
  fallbackNS: i18nConfig.defaultNamespaces,
  interpolation: {
    escapeValue: false,
  },
};

/** Init i18n */
export async function init(): Promise<void> {
  try {
    await i18next
      .use(LanguageDetector)
      .use(initReactI18next)
      .init(i18nextOptions);

    const { messages } = (await import(`./resource/${i18next.language}.ts`))
      .default;

    Object.entries(messages).forEach(([namespace, resources]) => {
      i18next.addResourceBundle(i18next.language, namespace, resources);
    });
  } catch (exception) {
    console.error(exception);
  }
}
